var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestTrialsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6604 16.834C11.8693 16.834 11.0959 16.5994 10.4381 16.1599C9.78032 15.7203 9.26763 15.0956 8.96488 14.3647C8.66213 13.6338 8.58292 12.8295 8.73726 12.0536C8.8916 11.2777 9.27257 10.565 9.83198 10.0056C10.3914 9.44615 11.1041 9.06519 11.88 8.91085C12.656 8.7565 13.4602 8.83572 14.1911 9.13847C14.922 9.44122 15.5468 9.95391 15.9863 10.6117C16.4258 11.2695 16.6604 12.0429 16.6604 12.834C16.6592 13.8945 16.2374 14.9112 15.4875 15.6611C14.7376 16.411 13.7209 16.8328 12.6604 16.834V16.834ZM12.6604 9.97684C12.0953 9.97684 11.5429 10.1444 11.0731 10.4584C10.6032 10.7723 10.237 11.2185 10.0207 11.7406C9.8045 12.2627 9.74791 12.8372 9.85816 13.3914C9.9684 13.9456 10.2405 14.4547 10.6401 14.8543C11.0397 15.2539 11.5488 15.526 12.103 15.6362C12.6572 15.7465 13.2317 15.6899 13.7538 15.4736C14.2759 15.2574 14.7221 14.8912 15.036 14.4213C15.35 13.9515 15.5175 13.3991 15.5175 12.834C15.5168 12.0765 15.2155 11.3502 14.6799 10.8145C14.1442 10.2789 13.4179 9.9776 12.6604 9.97684Z",
    fill: "url(#paint0_linear_2426_35426)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 14.0386L13.4382 12.9136V11.459H12.216V13.3794L13.7963 14.834L14.6604 14.0386ZM3.6604 9.20898H7.32707V10.334H3.6604V9.20898ZM3.6604 5.83398H10.9937V6.95898H3.6604V5.83398Z",
    fill: "url(#paint1_linear_2426_35426)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6604 1.99902C14.6601 1.69013 14.5371 1.39398 14.3184 1.17556C14.0996 0.957136 13.8031 0.834293 13.4937 0.833984H1.82707C1.51775 0.834293 1.22118 0.957136 1.00245 1.17556C0.783729 1.39398 0.660713 1.69013 0.660404 1.99902V9.57174C0.659104 10.7335 0.974657 11.8736 1.57319 12.8698C2.17173 13.866 3.03064 14.6806 4.05774 15.2262L7.07707 16.834V15.5134L4.60724 14.1981C3.76686 13.7517 3.06406 13.0852 2.57427 12.2702C2.08447 11.4551 1.82617 10.5223 1.82707 9.57174V1.99902H13.4937V7.24167H14.6604V1.99902Z",
    fill: "url(#paint2_linear_2426_35426)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2426_35426",
    x1: 12.6604,
    y1: 8.83398,
    x2: 12.6604,
    y2: 16.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2426_35426",
    x1: 9.1604,
    y1: 5.83398,
    x2: 9.1604,
    y2: 14.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2426_35426",
    x1: 7.6604,
    y1: 0.833984,
    x2: 7.6604,
    y2: 16.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTrialsIcon);
export default __webpack_public_path__ + "static/media/TestTrials_icon.0e0aaafa751bec7423dbc8a0342127af.svg";
export { ForwardRef as ReactComponent };